import dayjs from 'dayjs';
import React, { useState } from 'react';

import { Button, Popover, Table, Text } from '@mantine/core';

import { PersonPass } from '@/types/person';

import IconDelete from '@/shared/uikit/assets/icons/IconDelete.svg?react';
import IconEdit from '@/shared/uikit/assets/icons/IconEdit.svg?react';

import { IconCheck, IconX } from '@tabler/icons-react';

type PassesItemProps = {
	pass: PersonPass;
	handleEdit: (record: PersonPass) => void;
	handleDelete: (id: number) => Promise<void>;
};

const PassesItem: React.FC<PassesItemProps> = ({ pass, handleEdit, handleDelete }) => {
	const [isPopoverOpen, setIsPopoverOpen] = useState(false);

	return (
		<Table.Tr key={pass.id}>
			<Table.Td>
				<Text size="md" fw={600} lts="normal">
					{pass?.pass_type.name}
				</Text>
			</Table.Td>
			<Table.Td>
				<Text size="md" c="dimmed">
					{pass.car_number}
				</Text>
			</Table.Td>
			<Table.Td>
				<Text size="md" c="dimmed">
					{dayjs(pass.created_at).format('DD MMMM YYYY HH:mm')}
				</Text>
			</Table.Td>
			<Table.Td>
				<Text size="md" c="dimmed">
					{dayjs(pass.updated_at).format('DD MMMM YYYY HH:mm')}
				</Text>
			</Table.Td>
			<Table.Td>
				<Button.Group display="flex">
					<Button
						variant="transparent"
						size="compact-sm"
						radius="sm"
						color="balck"
						onClick={() => handleEdit(pass)}
					>
						<IconEdit fontSize={20} color="#667085" cursor="pointer" />
					</Button>
					<Popover
						position="top"
						withArrow
						shadow="md"
						opened={isPopoverOpen}
						onChange={setIsPopoverOpen}
					>
						<Popover.Target>
							<Button
								variant="transparent"
								size="compact-sm"
								radius="sm"
								color="balck"
								onClick={() => setIsPopoverOpen((prev) => !prev)}
							>
								<IconDelete fontSize={20} color="#667085" cursor="pointer" />
							</Button>
						</Popover.Target>
						<Popover.Dropdown p={8}>
							<Text size="xs">
								<Text ta="center" fz={13}>
									Удалить?
								</Text>
								<Button.Group mt={3}>
									<Button
										variant="light"
										size="compact-xs"
										radius="sm"
										onClick={() => handleDelete(pass.id)}
									>
										<IconCheck size={16} />
									</Button>
									<Button
										variant="light"
										size="compact-xs"
										radius="sm"
										color="red"
										onClick={() => setIsPopoverOpen(false)}
									>
										<IconX size={16} />
									</Button>
								</Button.Group>
							</Text>
						</Popover.Dropdown>
					</Popover>
				</Button.Group>
			</Table.Td>
		</Table.Tr>
	);
};

export default PassesItem;
